import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import handleHospital from "@/services/modules/hospital";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const { commaFormat, getPatientDetails } = figureFormatter();

    const exportToPDF = (company, invoice, customizationFields = []) => {
        const tableItems = invoice.has_item_detail ? invoice.general : invoice.ledgers;
        const footerText = customizationFields['extra_settings_footer_note'] && customizationFields['extra_settings_footer_note'].is_active ? 
                        customizationFields['extra_settings_footer_note'].value : null;
        var doc = {
            pageSize: { width: 204, height: 'auto' },
            pageMargins: [10, 10, 10, 20],

            content: [
                {
                    alignment: 'center',
                    image: company.logo64,
                    maxHeight: 40
                },
                {
                    text: company.name,
                    alignment: 'center',
                    bold: true,
                    margin: [0, 2, 0, 2],
                },
                {
                    text: company.address,
                    alignment: 'center',
                    bold: true,
                    margin: [0, 2, 0, 2],
                },
                {
                    text: company.phone,
                    alignment: 'center',
                    bold: true,
                    margin: [0, 2, 0, 2],
                },

                {
                    margin: [0, 5, 0, 5],
                    alignment: 'justify',
                    columns: [
                        {
                            width: '50%',
                            stack: [
                                {
                                    margin: [0, 2, 0, 2],
                                    alignment: 'left',
                                    width: '50%',
                                    text: [
                                        {
                                            text: 'Name: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: `${invoice.contact.name} (${invoice.contact_profile &&
                                            invoice.contact_profile.patient_id ?
                                                invoice.contact_profile.patient_id : invoice.contact.id})`,
                                            margin: [0, 2, 0, 2],
                                            bold: true,
                                        },
                                    ]
                                },
                                {
                                    margin: [0, 2, 0, 2],
                                    alignment: 'left',
                                    width: '50%',
                                    text: [
                                        {
                                            text: 'Mobile No: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: `${getPatientDetails(invoice.contact, 'mobile_no')}`,
                                            margin: [0, 2, 0, 2],
                                            bold: true,
                                        },
                                    ]
                                },
                            ]
                        },

                        {
                            alignment: 'right',
                            stack: [
                                {
                                    margin: [0, 2, 0, 2],
                                    text: [
                                        {
                                            text: 'DATE: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: formatToDdMmYy(invoice.date) + ' ' + invoice.created_at_time,
                                        }
                                    ]
                                },

                                {
                                    text: [
                                        {
                                            text: 'Invoice No: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: invoice.bill_number
                                        }
                                    ]
                                },
                            ]
                        },
                    ]
                },

                formattedDashLine(),

                {
                    table: {
                        widths: ['auto', '*', 'auto', 'auto', 'auto'],
                        body: [
                            [
                                { text: 'SL' },
                                { text: 'Item' },
                                { text: 'Qty', alignment: 'right' },
                                { text: 'Price', alignment: 'right'  },
                                { text: 'Amount', alignment: 'right' }
                            ],
                            ...tableItems.map((item, i) => [
                                { text: i + 1 },
                                { text: invoice.has_item_detail ? item.product.name : item.head.name },
                                { text: item.quantity ? commaFormat(item.quantity) : '',  alignment: 'right' },
                                { text: commaFormat(invoice.has_item_detail ? item.rate : 0), alignment: 'right' },
                                { text: commaFormat(item.quantity * item.rate), alignment: 'right' }
                            ])
                        ]
                    },
                    layout: 'noBorders'
                },

                formattedDashLine(),
                {
                    margin: [0, 10, 0, 0],
                    table: {
                        widths: ['*', 'auto'],
                        body: (() => {
                            let summary = [];

                            if (invoice.subtotal_amount) {
                                summary.push([
                                    { text: 'Total', bold: true },
                                    { text: commaFormat(invoice.subtotal_amount), alignment: 'right' }
                                ]);
                            }

                            if (invoice.vat_amount) {
                                summary.push([
                                    { text: 'VAT', bold: true },
                                    { text: commaFormat(invoice.vat_amount), alignment: 'right' }
                                ]);
                            }

                            if (totalDiscount(invoice) > 0) {
                                summary.push([
                                    { text: 'Discount', bold: true },
                                    { text: commaFormat(totalDiscount(invoice)), alignment: 'right' }
                                ]);
                            }

                            summary.push([
                                { text: 'Net Bill', bold: true },
                                { text: commaFormat(totalNetBillAmount(invoice)), alignment: 'right', bold: true }
                            ]);

                            summary.push([
                                { text: 'Paid'},
                                { text: commaFormat(invoice.paid_amount.toFixed(2)), alignment: 'right' }
                            ]);

                            summary.push([
                                { text: 'Due', bold: true },
                                { text: commaFormat(totalDue(invoice)), alignment: 'right', bold: true }
                            ]);

                            return summary;
                        })()
                    },
                    layout: 'noBorders'
                },

                formattedDashLine(),

                {
                    text: `*** ${footerText ? footerText : 'Thank You'} ***`,
                    alignment: 'center',
                    margin: [0, 20, 0, 0],
                }
            ],

            defaultStyle: {
                font: 'SulaimanLipi',
                fontSize: 8
            }
        };

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const formattedDashLine = (width = 206, margin = [0, 5, 0, 5]) => {
        return {
            canvas: [
                {
                    type: 'line',
                    x1: 0,
                    y1: 0,
                    x2: width,
                    y2: 0,
                    lineWidth: 1,
                    dash: { length: 2, space: 2 }
                }
            ],
            margin
        };
    }

    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }

    const totalDue = (invoice) => {
        let  totalDiscount = invoice.receipt_generals.reduce((sum, item) => sum + (item.discount_amount ?? 0), 0);
        return invoice.total_amount - (invoice.paid_amount + totalDiscount);
    }

    const totalDiscount = (invoice) => {
        let  totalDiscount = invoice.receipt_generals.reduce((sum, item) => sum + (item.discount_amount ?? 0), 0);
        totalDiscount += invoice.total_discount;
        return totalDiscount;
    }

    const totalNetBillAmount = (invoice) => {
        let totalDiscount = invoice.receipt_generals.reduce((sum, item) => sum + (item.discount_amount ?? 0), 0);
        return invoice.total_amount - totalDiscount;
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
